<template>
    <div class="user-info">
      <div class="basic card-box">
        <h4 class="title">基本信息</h4>
        <el-row :gutter="20">
          <el-col
            :lg="12"
            :md="12"
            :sm="24"
          >
            <div class="item master ">
              <div class="line">
                <span>ID</span>
                <span>{{userInfo.id}}</span>
              </div>
<!--              判断,类型为个人,没有密钥这一项-->
              <div class="line">
                <span>类型</span>
                <span>{{typeComputed}}</span>
              </div>
              <div
                v-if="userInfo.merMd5Key"
                class="line">
                <span>API密钥</span>
                <span>{{userInfo.merMd5Key}}</span>
              </div>
              <div class="line">
                <span>绑定手机</span>
                <span>{{userInfo.nationCode}} {{userInfo.phone}}</span>
              </div>
              <div class="line">
                <span>登录密码</span>
                <span>{{isSettingLoginPass}}</span>
              </div>
              <div class="line">
                <span>资金密码</span>
                <span>{{isSettingFundsPass}}</span>
              </div>
              <div class="line">
                <span>创建时间</span>
                <span>{{userInfo.createTime}}</span>
              </div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="item sub">
              <div class="line">
                <span>总资产 (USDT)</span>
                <span>{{userInfo.usdtTotal}}</span>
              </div>
              <div class="line">
                <span>冻结金额 (USDT)</span>
                <span>{{userInfo.usdtFrozen}}</span>
              </div>
              <div class="line">
                <span>钱包地址</span>
                <span>{{userInfo.address}}</span>
              </div>
              <div class="line">
                <span>二维码</span>
                <span>
                  <el-image
                    class="qrcode-img"
                    v-if="userInfo.qrUrl"
                    :src="userInfo.qrUrl"
                    :preview-src-list="[userInfo.qrUrl]"
                  ></el-image>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="basic card-box">
        <h4 class="title">身份验证 <span class="audit-status" v-if="userInfo.auditStatus !== ''">{{auditStatus}}</span></h4>
        <el-row :gutter="20">
          <el-col
            :lg="12"
            :md="12"
            :sm="24"
          >
            <div class="item master ">
              <div class="line">
                <span>姓名 </span>
                <span>{{userInfo.custName || userInfo.fullName}}</span>
              </div>
              <div class="line">
                <span>国家/地区</span>
                <span>{{userInfo.region}}</span>
              </div>
              <!--              判断,类型为个人,没有密钥这一项-->
              <div class="line">
                <span>证件类型</span>
                <span v-if="userInfo.certType">{{ certType}}</span>
              </div>
              <div class="line">
                <span>证件号码</span>
                <span>{{userInfo.certId}}</span>
              </div>
            </div>
          </el-col>

          <el-col :span="12">
            <div class="item sub">
              <div class="line">
                <span>验证图片 (正面)</span>
                <span>
                  <el-image
                    v-if="userInfo.certImgFront"
                    class="qrcode-img"
                    :src="userInfo.certImgFront"
                    :preview-src-list="[userInfo.certImgFront]"
                  ></el-image>
                </span>
              </div>
              <div class="line">
                <span>验证图片 (反面)</span>
                <span>
                  <el-image
                    v-if="userInfo.certImgBack"
                    class="qrcode-img"
                    :src="userInfo.certImgBack"
                    :preview-src-list="[userInfo.certImgBack]"
                  ></el-image>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
    export default {
        name: "userInfo",
      props: {
        userInfo: {
          type: Object,
          default(){
            return {
            }
          }
        },
      },
      computed: {
        typeComputed() {
          switch (this.userInfo.custType) {
            case 1:
              return '商户';
            case 2:
              return '个人'
          }
        },
        isSettingLoginPass(){
          if(this.userInfo.setLogin){
            return '已设置';
          }else {
            return '未设置';
          }
        },
        isSettingFundsPass(){
          if(this.userInfo.setTrade){
            return '已设置';
          }else {
            return '未设置';
          }
        },
        auditStatus(){
          // 未认证, 待审核, 审核通过,审核拒绝
          switch (this.userInfo.auditStatus) {
            case 0:
              return '未认证';
            case 1:
              return '待审核';
            case 2:
              return '审核拒绝';
            case 3:
              return '审核通过';
          }
        },
        certType(){
          if(this.userInfo.certType == 1){
            return '身份证';
          }else {
            return '护照'
          }
        }
      },
    }
</script>

<style lang="scss" scoped>
.user-info {
  .qrcode-img {
    width: 80px;
    height: 80px;
  }
  .card-box {
    background-color: #ffffff;
    padding: 1.4rem;
    border-radius: 6px;
    margin-bottom: 1rem;
    .title {
      margin-bottom: 1rem;
    }
    .item {
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.2rem;
        color: #6E6B7B;
      }
      &.master {
        border-right: 1px solid #EBE9F1;
        padding-right: 20px;
      }
    }
    .audit-status {
      padding: 2px 10px;
      background-color: rgba(108, 117, 125, 0.12);
      font-size: 8px;
      border-radius: 10px;
    }
  }
}
</style>
